function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "none",
  d: "M292.6,418.5c-0.3-0.5-0.9-1.4-1.8-2.7c-0.6-1-1.1-1.7-1.5-2.1l-0.2-0.2c-0.4,0.4-0.6,0.8-0.8,1.1c-0.2,0.5-0.3,1-0.3,1.6 v2.2h-1.8v-1.3c0-1.2,0.2-2.2,0.6-3c0.3-0.6,0.8-1.2,1.5-1.8l-0.2-0.2c-0.3-0.4-0.7-0.9-1.2-1.5l-1.1-1.2h2.3 c0.3,0.3,0.8,0.9,1.4,1.7c0.5,0.6,1.2,1.5,2,2.6c0,0,0.1-0.1,0.3-0.3c0.2-0.3,0.3-0.5,0.4-0.6c0.2-0.4,0.2-0.8,0.2-1.3v-2h1.8v1.5 c0,0.7-0.1,1.3-0.3,1.9c-0.3,0.7-0.8,1.4-1.7,2l1.4,2.2c0.2,0.3,0.5,0.8,0.8,1.4H292.6z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "current",
  strokeLinejoin: "round",
  d: "M297.2,430.4c-5.1,0-9.3-3.9-9.7-8.9"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "none",
  points: "291,423.5 290.6,424.1 287.7,421.8 285.6,424.8 285,424.4 287.5,420.7  "
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "current",
  strokeLinejoin: "round",
  d: "M297.2,411c5.1,0,9.3,3.9,9.7,8.9"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "none",
  points: "303.5,417.8 303.9,417.3 306.8,419.6 308.9,416.5 309.5,417 307,420.7  "
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "none",
  d: "M303.5,421.7h1.8l3.7,9.5h-1.8l-0.9-2.5h-3.8l-0.9,2.5h-1.7L303.5,421.7z M302.9,427.4h2.9l-1.4-4.1h0L302.9,427.4z"
}));

var SvgLanguageChange = function SvgLanguageChange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "285.1 408.4 25 25",
    enableBackground: "new 285.1 408.4 25 25",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLanguageChange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/language_change.884d5a90.svg";
export { ForwardRef as ReactComponent };